import { render, staticRenderFns } from "./add-screenshots.vue?vue&type=template&id=2465aa80&"
import script from "./add-screenshots.vue?vue&type=script&lang=js&"
export * from "./add-screenshots.vue?vue&type=script&lang=js&"
import style0 from "./add-screenshots.vue?vue&type=style&index=0&id=2465aa80&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports